<template>
	<div class="produk">
		<router-view></router-view>
	</div>
</template>

<script>
export default {
	name: 'Produk'
}
</script>